const WORKING_HOLIDAY_NAMES = new Set(['working holiday', 'work holiday', 'vacances travail']);

/** Catalog file questions/canada/express-entry.json. */
export const EXPRESS_ENTRY_PROGRAM_ID = 'Express Entry';

function compactName(value: string): string {
    return value
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

function isCanada(country?: string | null): boolean {
    return compactName(country ?? '') === 'canada';
}

/** Program questions for the selected Canada Working Holiday application. */
export function isCanadaWorkingHoliday(
    country?: string | null,
    programName?: string | null
): boolean {
    if (!isCanada(country)) return false;
    return WORKING_HOLIDAY_NAMES.has(compactName(programName ?? ''));
}

/** Federal and provincial programs whose name is an Express Entry program. */
export function isCanadaExpressEntry(
    country?: string | null,
    programName?: string | null
): boolean {
    if (!isCanada(country)) return false;
    const name = compactName(programName ?? '');
    if (!name || name.includes('non express entry') || name.includes('non entree express')) {
        return false;
    }
    return name.includes('express entry') || name.includes('entree express');
}
